import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UtilService } from '../util/util.service';

export const authGuard: CanActivateFn = (_route, state) => {
  const util = inject(UtilService);
  const router = inject(Router);
  if (util.getJWT()) {
    return true;
  }
  router.navigate(['/login'], {
    queryParams: state.url !== '/' ? { returnUrl: state.url } : {}
  });
  return false;
};
